<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-11-14 14:18:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-16 15:40:02
 * @FilePath: \common_web\src\page\index\top\top-notice.vue
-->
<template>
  <!-- <el-badge :value="noticeVal" class="item"> -->
  <el-popover placement="bottom"
              width="350"
              trigger="click">

    <el-tabs v-model="activeName">

      <el-tab-pane label="通知"
                   name="third" ></el-tab-pane>
    </el-tabs>
    <el-scrollbar style="height:300px">
      <avue-notice :data="data"
                   :option="option"
                   @click="clicknotice"
                  @page-change="pageChange"
                   ></avue-notice>
    </el-scrollbar>
    <div slot="reference">
      <el-badge :value="noticeVal">
        <i class="el-icon-bell"></i>
      </el-badge>
    </div>
  </el-popover>
<!-- </el-badge> -->
</template>

<script>

import {mapGetters} from "vuex";
import {factoryNoticelist,generalNoticelist,checkcunt, shopNoticelist } from '@/api/user.js'
export default {
  name: "top-notice",
  data () {
    return {
      activeName: 'first',
      option: {
        props: {
          img: 'img',
          title: 'title',
          subtitle: 'subtitle',
          tag: 'tag',
          status: 'status'
        },
      },
      // data: list,
      data: [],
      timer:null,
      value:''
    }
  },
  computed: {
    ...mapGetters(["noticeVal"]),
  },
  created () {
    this.getfactoryNoticelist()
  },
  beforeDestroy(){
     clearInterval(this.timer)
        this.timer = null
  },
  methods: {
    clicknotice(e){
      console.log(e)
      // this.$router.push({name:'档案审核',params:{id:e.id,type:e.type}})
    },
    settime(){
      if(this.timer){
        clearInterval(this.timer)
        this.timer = null
      }
       this.timer = setInterval(()=>{
        this.getfactoryNoticelist()
       },60000)
    },
    getphoto(type){
      let photo = ''
      if(type==1||type==2||type==3){
        photo = '/img/bg/da.png'
      }else if(type==8){
        photo = '/img/bg/bx.png'
      }else if(type==9){
          photo = '/img/bg/ts.png'
      }else if(type==12){
          photo = '/img/bg/zt.png'
      }else{
       photo = '/img/bg/dd.png'
      }
      return photo
    },
    getfactoryNoticelist(){
      let pro = this.website.roleType == "factory" ?factoryNoticelist:(this.website.roleType=='gen'?generalNoticelist: shopNoticelist)
      pro().then(res=>{
        if(res.data.code==200){
          let arr = []
          res.data.data.map(item=>{
            arr.push({
              img:this.getphoto(item.status),
              title:item.noticeTitle,
              subtitle:item.noticeContent,
              tag:item.statusValue,
              status:item.status,
              id:item.businessId,
              type:item.type
            })
          })
          this.data = arr
        }
      })

      this.$store.dispatch("Getnotice").then(res=>{
        console.log(this.noticeVal,res)
      })

    },
    pageChange (page, done) {
      setTimeout(() => {
        // this.$message.success('页码' + page)
        // this.data = this.data.concat(list);
        done();
      }, 1000)

    },
  }
};
</script>

<style lang="scss" scoped>
</style>
